// extracted by mini-css-extract-plugin
export default {"actions":"leagues_actions__M1bsV"};